import React from 'react'
import Img from 'gatsby-image';
import {Link} from 'gatsby';
import { useRelatedPosts } from "./RelatedPosts.data.js"
import { useInView } from 'react-intersection-observer';

export default function RelatedPosts(data) {

    const { ref, inView, entry } = useInView({
        /* Optional options */
        threshold: 0,
        triggerOnce: true
    });
    const {category, id} = data;
    const queryData = useRelatedPosts();
    
    const relatedPosts = queryData.edges.filter((relatedPost) => {
        if(relatedPost.node.blogCats.nodes[0].slug === category && relatedPost.node.id !== id){
            return relatedPost
        }
    })


    return (
        <section className="the_posts-wrap">
            <div ref={ref} className={`the_posts ${inView ? 'is_inview' : ''}`}>
            <div className="wrapper">      
                <label className="main_label">Related Articles</label>
                {relatedPosts.map((post, index) => {
                    if(index + 1 <= 4){

                        return(
                            <article className="post">
                            <Link className="image-link" to={post.node.link} title={post.node.title}>
                                {post?.node?.acf_customFeaturedImage?.customFeaturedImage?.localFile?.childImageSharp?.fluid ? '' : "image not found"}
                                <Img 
                                fluid={post?.node?.acf_customFeaturedImage?.customFeaturedImage?.localFile?.childImageSharp?.fluid} 
                                alt={post?.node?.acf_customFeaturedImage?.customFeaturedImage?.altText} 
                                className="bg-cover BG bgStretch" />
                                <div className="indent_text">{post.node.title}</div>
                            </Link>
                            {
                                post.node.blogCats.nodes.map((cats) => {
                                return(
                                    <Link to={cats.link}><div className="label">{cats.name}</div></Link>
                                )
                                })
                            }
                            
                            <h2>
                                <Link to={post.node.link} title={post.node.title}>{post.node.title}</Link>
                            </h2>
                            
                            <div className="author_date">
                                <span>By </span><Link to={'/author/'+post.node.author.node.name.replace(/\s+/g, '-').toLowerCase()+'/'}>{post.node.author.node.firstName}</Link><span> | {post.node.date} </span>
                            </div>   
                            </article>
                        )
                    }
                })}
            </div>
            </div>
        </section>
    )
}
